<template>
  <div>
    <div class="father">
      <div class="tab-item">
        <div class="item-time" v-if="isNeedtransitions" >
          <span>需要转场</span>
        </div>
        <div class="item-time" v-else >
          <div class="item-time-left">
            不需要转场
          </div>
        </div>
        <div class="item-height" v-if="!popData[1]">
          <div class="left">初始配额</div>
          <div class="right">
            <span v-if="popData[0].themeDetail.themeLevelName">{{ popData[0].themeDetail.themeLevelName }} ：</span>
            <span>{{ formatPrice(popData[0].curAssignObj.assignQty) }}</span>
            <span> {{ showText }}</span>
          </div>
        </div>
        <div class="item-height" v-else>
          <div class="left">初始配额</div>
          <div class="right" v-if="!isInterval">
            <span v-if="popData[0]"
              >{{ popData[0].themeDetail.themeLevelName }}：</span
            >
            <span v-if="popData[0]" class="right-30">{{ formatPrice(numStart1) }} {{ showText }}</span>
            <span v-if="popData[1]"
              >{{ popData[1].themeDetail.themeLevelName }}：</span
            >
            <span v-if="popData[1]" class="right-30">{{ formatPrice(numStart2) }} {{ showText }}</span>
            <span v-if="popData[2]"
              >{{ popData[2].themeDetail.themeLevelName }}：</span
            >
            <span v-if="popData[2]">{{ formatPrice(numStart3) }} {{ showText }}</span>
          </div>
        </div>
        <div class="item-height">
          <div class="left">单场投入预算</div>
          <div class="right">
            <span v-if="popData[0].themeDetail.themeLevelName">{{ popData[0].themeDetail.themeLevelName }}：</span>
            <span class="right-30" v-if="popData[0]">{{ formatPrice(popData[0].themeDetail.investUnit) }}</span>
            <span  v-if="popData[1]">{{ popData[1].themeDetail.themeLevelName }}：</span>
            <span class="right-30" v-if="popData[1]">{{ formatPrice(popData[1].themeDetail.investUnit) }}</span>
            <span  v-if="popData[2]">{{ popData[2].themeDetail.themeLevelName }}：</span>
            <span class="right-30" v-if="popData[2]">{{ formatPrice(popData[2].themeDetail.investUnit) }}</span>
          </div>
        </div>
        <div class="item-height" v-if="!isNeedtransitions">
          <div class="left">执行天数</div>
          <div class="right">
            <span v-if="popData[0].themeDetail.themeLevelName">{{ popData[0].themeDetail.themeLevelName }}：</span>
            <span v-if="popData[0]" class="right-30" >{{formatPrice(popData[0].themeDetail.perExecDays)}} 天</span>
            <span v-if="popData[1]">{{ popData[1].themeDetail.themeLevelName }}：</span>
            <span v-if="popData[1]" class="right-30" >{{formatPrice(popData[1].themeDetail.perExecDays)}} 天</span>
            <span v-if="popData[2]">{{ popData[2].themeDetail.themeLevelName }}：</span>
            <span v-if="popData[2]" class="right-30" >{{formatPrice(popData[2].themeDetail.perExecDays)}} 天</span>
          </div>
        </div>
        <div class="item-height2" v-if="popData[1]">
          <div class="left">可分配</div>
          <div class="right" v-if="!isInterval">
            <div class="right-top">
              <div v-if="popData[0]">
                <span>{{ popData[0].themeDetail.themeLevelName }}：</span>
                <span class="right-30"> {{ formatPrice(redNum1) }} {{ showText }}</span>
              </div>
              <div v-if="popData[1]">
                <span>{{ popData[1].themeDetail.themeLevelName }}：</span>
                <span class="right-30"> {{ formatPrice(redNum2) }} {{ showText }}</span>
              </div>
              <div v-if="popData[2]">
                <span >{{ popData[2].themeDetail.themeLevelName }}：</span>
                <span class="right-30">{{ formatPrice(redNum3) }} {{ showText }}</span>
              </div>
              <div v-if="popData[0]">
                <span>可分配预算：</span>
                <span class="right-30"> {{ formatPrice(redNumall) }}</span>
              </div>
            </div>
            <div class="right-change">
              <span v-if="popData[0]">{{ popData[0].themeDetail.themeLevelName }}：</span>
              <div class="number right-40">
                <numberInput
                  v-model="num1"
                  :max="numMax1"
                  strictly
                  @handleClick="handleChange1(num1)"
                ></numberInput>
              </div>
              <span v-if="popData[1]"
                >{{ popData[1].themeDetail.themeLevelName }}：</span
              >
              <div v-if="popData[1]" class="number right-40">
                <numberInput
                  v-model="num2"
                  :max="numMax2"
                  strictly
                  @handleClick="handleChange2(num2)"
                ></numberInput>
              </div>
              <span v-if="popData[2]"
                >{{ popData[2].themeDetail.themeLevelName }}：</span
              >
              <div v-if="popData[2]" class="number">
                <numberInput
                  v-model="num3"
                  :max="numMax3"
                  strictly
                  @handleClick="handleChange3(num3)"
                ></numberInput>
              </div>
            </div>
          </div>
        </div>
        <div class="line-reason" v-if="getRejectreason"></div>
        <div class="item-height" v-if="getRejectname">
          <div class="left">退回用户</div>
          <div class="right">{{getRejectname}}</div>
        </div>
        <div class="item-height" v-if="getRejectreason">
          <div class="left">退回原因</div>
          <div class="right">{{getRejectreason}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import numberInput from "./numberInput.vue";
import DialogPop from "./dialog-pop.vue";
export default {
  name: "quotaWait-confirmed-pop-table",
  props: {
    timeItem:{type:Object, default:()=>{}},
    allTimearr:{type:Object, default:()=>{}},
  },
  components: {
    numberInput,
    DialogPop,
  },
  data() {
    return {
      num1: 0,
      num2: 0,
      num3: 0,
      isNum1: false,
      isNum2: false,
      isNum3: false,
      isChangeNumer: false,
      numList: {}, // 传给父组件的数据
      isBtn: false,
      popData: [],
      numStart1: "",
      numStart2: "",
      numStart3: "",
      nextLevelRate1: "",
      nextLevelRate2: "",
      nextLevelRate3: "",
      isTwo: false,
      isThree: false,
      showText:'', // 单位 场 售点 街区
      allTimelist: [],
      isIntervalTwo: false,
      isIntervalThree: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // redNum1() {
    //   if (!this.isInterval) {
    //     if (this.isTwo == true) {
    //       return parseInt(this.redNumall / this.nextLevelRate1);
    //     } else if (this.isThree == true) {
    //       return parseInt(this.redNumall / this.nextLevelRate1 / this.nextLevelRate2);
    //     } else {
    //       return 0
    //     }
    //   } else {
    //     if (this.isIntervalTwo == true) {
    //       return parseInt(this.redNumall / this.nextLevelRate1);
    //     } else if (this.isIntervalThree == true) {
    //       return parseInt(this.redNumall / this.nextLevelRate1 / this.nextLevelRate2);
    //     }
    //   }
    // },
    // redNum2() {
    //   if (!this.isInterval) {
    //     if (this.isTwo == true) {
    //       return parseInt(this.redNumall);
    //     } else if (this.isThree == true) {
    //       return parseInt(this.redNumall / this.nextLevelRate2);
    //     } else {
    //       return 0
    //     }   
    //   } else {
    //     if (this.isIntervalTwo == true) {
    //       return parseInt(this.redNumall);
    //     } else if (this.isIntervalThree == true) {
    //       return parseInt(this.redNumall / this.nextLevelRate2); 
    //     }
    //   }
    // },
    // redNum3() {
    //   return this.redNumall;
    // },
    // redNumall() {
    //   if (!this.isInterval) {
    //     if (this.isTwo == true) {
    //     return (
    //       (this.numStart1 - this.num1) * this.nextLevelRate1 +
    //       (this.numStart2 - this.num2)
    //     );
    //   } else if (this.isThree == true) {
    //     return (
    //       (this.numStart1 - this.num1) *this.nextLevelRate1 *this.nextLevelRate2 +
    //       (this.numStart2 - this.num2) * this.nextLevelRate2 +
    //       (this.numStart3 - this.num3)
    //     );
    //   } else {
    //     return 0
    //   } 
    //   } else {
    //     if (this.isIntervalTwo == true) {
    //       return (
    //       (this.numStart1 - this.num1) * this.nextLevelRate1 +
    //       (this.numStart2 - this.num2)
    //     );
    //     } else if (this.isIntervalThree == true) {
    //       return (
    //       (this.numStart1 - this.num1) *this.nextLevelRate1 *this.nextLevelRate2 +
    //       (this.numStart2 - this.num2) * this.nextLevelRate2 +
    //       (this.numStart3 - this.num3)
    //     ); 
    //     } else {   
    //       return
    //     } 
    //   }

    // },
    // startNumall() {
    //   if (this.isTwo == true) {
    //     return this.numStart1 * this.nextLevelRate1 + this.numStart2;
    //   } else if (this.isThree == true) {
    //     return (
    //       this.numStart1 * this.nextLevelRate1 * this.nextLevelRate2 +
    //       this.numStart2 * this.nextLevelRate2 +
    //       this.numStart3
    //     );
    //   } else {
    //     return 0
    //   }
    // },
    // numMax1() {
    //   return this.num1 + this.redNum1;
    // },
    // numMax2() {
    //   return this.num2 + this.redNum3;
    // },
    // numMax3() {
    //   return this.num3 + this.redNum3;
    // },
    redNum1() {
      if (this.isNeedtransitions) {
        if (this.popData[0]) {
          return parseInt(this.redNumall / this.popData[0].themeDetail.investUnit);
        } else {
          return
        }  
      } else {
        if (this.popData[0]) {
          return parseInt(this.redNumall / this.popData[0].themeDetail.investUnit / this.popData[0].themeDetail.perExecDays);
        }  else {
          return
        }  
      }
    },
    redNum2() {
      if (this.isNeedtransitions) {
        if (this.popData[1]) {
          return parseInt(this.redNumall / this.popData[1].themeDetail.investUnit);
        } else {
          return
        }       
      } else {
        if (this.popData[1]) {
          return parseInt(this.redNumall / this.popData[1].themeDetail.investUnit / this.popData[1].themeDetail.perExecDays);
        } else {
          return
        }
      }
    },
    redNum3() {
      if (this.isNeedtransitions) {
        if (this.popData[2]) {
          return parseInt(this.redNumall / this.popData[2].themeDetail.investUnit);
        } else {
          return
        }
      } else {
        if (this.popData[2]) {
          return parseInt(this.redNumall / this.popData[2].themeDetail.investUnit / this.popData[2].themeDetail.perExecDays);
        } else {
          return
        }
      }
    },
    redNumall() {
      if (this.isNeedtransitions) {
        if (this.isTwo) {
          return (
            (this.numStart1 - this.num1) * this.popData[0].themeDetail.investUnit +
            (this.numStart2 - this.num2) * this.popData[1].themeDetail.investUnit 
          );
        } else if (this.isThree) {
          return (
            (this.numStart1 - this.num1) * this.popData[0].themeDetail.investUnit +
            (this.numStart2 - this.num2) * this.popData[1].themeDetail.investUnit  +
            (this.numStart3 - this.num3) * this.popData[2].themeDetail.investUnit 
          );
        } else {
          return 0
        }
        
      } else {
        if (this.isTwo) {
        return (
          (this.numStart1 - this.num1) * this.popData[0].themeDetail.investUnit * this.popData[0].themeDetail.perExecDays +
          (this.numStart2 - this.num2) * this.popData[1].themeDetail.investUnit * this.popData[1].themeDetail.perExecDays
        );
      } else if (this.isThree) {
          return (
            (this.numStart1 - this.num1) * this.popData[0].themeDetail.investUnit * this.popData[0].themeDetail.perExecDays +
            (this.numStart2 - this.num2) * this.popData[1].themeDetail.investUnit * this.popData[1].themeDetail.perExecDays +
            (this.numStart3 - this.num3) * this.popData[2].themeDetail.investUnit * this.popData[2].themeDetail.perExecDays
          );
        } else {
          return 0
        }
      }
    },
    numMax1() {
      return this.num1 + this.redNum1;
    },
    numMax2() {
      return this.num2 + this.redNum2;
    },
    numMax3() {
      return this.num3 + this.redNum3;
    },
    isNeedtransitions() {
      let isShow =  this.timeItem.children.every(item=>{
          return item.themeDetail.needTransitions == 1
      })
      return isShow
    },
    // 是否间隔大于1
    isInterval() {
      return false
      if ( this.popData.length  ==  1) {
        return false
      } else if (this.popData.length  ==  2) {
        let numBegin = this.popData[0].themeDetail.themeLevelCode.slice(-1)
        let numEnd = this.popData[1].themeDetail.themeLevelCode.slice(-1)
        let Interval =  Math.abs(numBegin-numEnd)
        // console.log(Interval,'Interval');
        // console.log(numBegin,'numBegin');
        // console.log(numEnd,'numEnd');
        if (Interval > 1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    // 获取理由
    getRejectreason(){
      let name = null
      for (let item of this.popData) {
        if (item.themeDetail.rejectReason) {
          name = item.themeDetail.rejectReason
        }
      }
      // console.log(name,'reason',this.popData);
      return name
    },
    getRejectname() {
      let name = null
      for (let item of this.popData) {
        if (item.themeDetail.rejectPerson) {
          name = item.themeDetail.rejectPerson
        }
      }
      return name
    }
  },
  watch: {
    num1: {
      handler(newValue, oldValue) {
        if (newValue !== this.numStart1) {
          this.isNum1 = true;
          // this.saveChange()
        } else {
          this.isNum1 = false;
        }
        this.saveChange()
      },
    },
    num2: {
      handler(newValue, oldValue) {
        if (newValue !== this.numStart2) {
          this.isNum2 = true;
          // this.saveChange()
        } else {
          this.isNum2 = false;
        }
        this.saveChange()
      },
    },
    num3: {
      handler(newValue, oldValue) {
        if (newValue !== this.numStart3) {
          this.isNum3 = true;
          // this.saveChange()
        } else {
          this.isNum3 = false;
        }
        this.saveChange()
      },
    },
    redNum1: {
      handler(newValue, oldValue) {
        if (newValue < 0) {
          this.$message.error("分配不能小于0");
        }
      },
      // immediate:true
    },
    redNum2: {
      handler(newValue, oldValue) {
        if (newValue < 0) {
          this.$message.error("分配不能小于0");
        }
      },
      // immediate:true
    },
    redNum3: {
      handler(newValue, oldValue) {
        if (newValue < 0) {
          this.$message.error("分配不能小于0");
        }
      },
      // immediate:true
    },
    redNumall: {
      handler(newValue, oldValue) {
        if (newValue < 0) {
          this.$message.error("分配不能小于0");
        }
      },
    },
  },
  created() {
    this.popData = this.timeItem.children;
    this.allTimelist = this.allTimearr.children;
    // console.log(this.popData, "配额修改/确认 详情---孙组件--popData");
    // console.log(this.allTimelist, "配额修改/确认 详情---孙组件--allTimelist");

    let needTransitions = this.timeItem.children[0].themeDetail.needTransitions
    let pocRelateType = this.timeItem.children[0].themeDetail.pocRelateType
    if (needTransitions == '1') {
      // 转场
      this.showText = '场'
    } else if (needTransitions == '0') {
      // 不转场
      if (pocRelateType == '1') {
        // 不转场 单售点
        this.showText = '售点'
      } else if (pocRelateType == '0') {
        // 不转场 无售点
        this.showText = '地点'
      } else if (pocRelateType == '2') {
        // 不转场 多售点
        this.showText = '街区'
      }
    }
    // console.log(needTransitions,'needTransitions',pocRelateType,'pocRelateType');
    this.init();
  },
  mounted() {},
  updated() {},
  methods: {
    init() {
      this.judgeInterval()
      if ( this.popData.length == 2) {
        this.isTwo = true;
      } else if (this.popData.length == 3) {
        this.isThree = true;
      } else {
        return
      }
    },
    // 金额千分
    formatPrice(price) {
        return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    judgeInterval() {
      if (!this.isInterval) {
        if (this.popData.length == 1) {
          this.num1 = this.popData[0].curAssignObj.assignQty;

          this.nextLevelRate1 = this.popData[0].themeDetail.nextLevelRate;

          this.numStart1 = this.popData[0].curAssignObj.assignQty;

        } else if (this.popData.length == 2) {
          this.num1 = this.popData[0].curAssignObj.assignQty;
          this.num2 = this.popData[1].curAssignObj.assignQty;

          this.nextLevelRate1 = this.popData[0].themeDetail.nextLevelRate;
          this.nextLevelRate2 = this.popData[1].themeDetail.nextLevelRate;

          this.numStart1 = this.popData[0].curAssignObj.assignQty;
          this.numStart2 = this.popData[1].curAssignObj.assignQty;

        } else if (this.popData.length == 3) {
          this.num1 = this.popData[0].curAssignObj.assignQty;
          this.num2 = this.popData[1].curAssignObj.assignQty;
          this.num3 = this.popData[2].curAssignObj.assignQty;

          this.nextLevelRate1 = this.popData[0].themeDetail.nextLevelRate;
          this.nextLevelRate2 = this.popData[1].themeDetail.nextLevelRate;
          this.nextLevelRate3 = this.popData[2].themeDetail.nextLevelRate;

          this.numStart1 = this.popData[0].curAssignObj.assignQty;
          this.numStart2 = this.popData[1].curAssignObj.assignQty;
          this.numStart3 = this.popData[2].curAssignObj.assignQty;

        }
      } else {
        if (this.allTimelist.length == 1) {
          this.num1 = this.allTimelist[0].curAssignObj.assignQty;

          this.nextLevelRate1 = this.allTimelist[0].themeDetail.nextLevelRate;

          this.numStart1 = this.allTimelist[0].curAssignObj.assignQty;
        } else if (this.allTimelist.length == 2) {
          this.num1 = this.allTimelist[0].curAssignObj.assignQty;
          this.num2 = this.allTimelist[1].curAssignObj.assignQty;

          this.nextLevelRate1 = this.allTimelist[0].themeDetail.nextLevelRate;
          this.nextLevelRate2 = this.allTimelist[1].themeDetail.nextLevelRate;

          this.numStart1 = this.allTimelist[0].curAssignObj.assignQty;
          this.numStart2 = this.allTimelist[1].curAssignObj.assignQty;

        } else if (this.allTimelist.length == 3) {
          this.num1 = this.allTimelist[0].curAssignObj.assignQty;
          this.num2 = this.allTimelist[1].curAssignObj.assignQty;
          this.num3 = this.allTimelist[2].curAssignObj.assignQty;

          this.nextLevelRate1 = this.allTimelist[0].themeDetail.nextLevelRate;
          this.nextLevelRate2 = this.allTimelist[1].themeDetail.nextLevelRate;
          this.nextLevelRate3 = this.allTimelist[2].themeDetail.nextLevelRate;

          this.numStart1 = this.allTimelist[0].curAssignObj.assignQty;
          this.numStart2 = this.allTimelist[1].curAssignObj.assignQty;
          this.numStart3 = this.allTimelist[2].curAssignObj.assignQty;

          // this.isThree = true;
        }
      }
    },
    getTime (timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return ''
            } else {
                var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D
            }
        },

    // 保存变更
    saveChange() {
      // if (this.isNum1 == 0 && this.isNum2 == 0 && this.isNum3 == 0) {
      //   this.isChangeNumer = false;
      //   this.isBtn = false;
      // } else {
      //   if (this.redNum1 < 0 || this.redNum2 < 0 || this.redNum3 < 0) {
      //     this.$message.warning("不能超过初始配额总数");
      //     return;
      //   } else {
      //     this.isChangeNumer = true;
      //     this.isBtn = false;
      //   }
      // }

      if (this.popData.length == 1) {
        let list1 = this.popData[0].curAssignObj;
        if (this.isNum1 == 0 ) {
          this.isChangeNumer = false;
        } else {
          this.isChangeNumer = true;
          // list1.buChangeQty = this.num1;
        }
        list1.buChangeQty = this.num1;
        list1.leftNum = this.redNum1
        this.numList = {
          changeType: this.isChangeNumer,
          list1,
          popData: this.popData,
          assignEndTime:this.timeItem.assignEndTime,
          assignStartTime:this.timeItem.assignStartTime,
          redNumall:this.redNumall
        };
      } else if (this.popData.length == 2) {
        let list1 = this.popData[0].curAssignObj;
        let list2 = this.popData[1].curAssignObj;
        if (this.isNum1 == 0 && this.isNum2 == 0 ) {
          this.isChangeNumer = false;
        } else {
          this.isChangeNumer = true;
          // list1.buChangeQty = this.num1;
          // list2.buChangeQty = this.num2;
        }
        list1.buChangeQty = this.num1;
        list2.buChangeQty = this.num2;
        list1.leftNum = this.redNum1
        list2.leftNum = this.redNum2
        if (!this.isInterval) {
          list1.buChangeQty = this.num1;
          list2.buChangeQty = this.num2;
          list1.leftNum = this.redNum1
          list2.leftNum = this.redNum2
        } else {
          list1.buChangeQty = this.num1;
          list2.buChangeQty = this.num3;
          list1.leftNum = this.redNum1
          list2.leftNum = this.redNum3
          if (this.allTimelist.length  == 2) {
            list1.nextLevelRate = this.allTimelist[0].themeDetail.nextLevelRate
          }
          if (this.allTimelist.length  == 3) {
            list1.nextLevelRate = this.allTimelist[0].themeDetail.nextLevelRate * this.allTimelist[1].themeDetail.nextLevelRate
          }
          list1.isInterval = true
        }

        this.numList = {
          changeType: this.isChangeNumer,
          list1,
          list2,
          popData: this.popData,
          assignEndTime:this.timeItem.assignEndTime,
          assignStartTime:this.timeItem.assignStartTime,
          redNumall:this.redNumall
        };
      } else if (this.popData.length == 3) {
        let list1 = this.popData[0].curAssignObj;
        let list2 = this.popData[1].curAssignObj;
        let list3 = this.popData[2].curAssignObj;
        if (this.isNum1 == 0 && this.isNum2 == 0 && this.isNum3 == 0) {
          this.isChangeNumer = false;
        } else {
          this.isChangeNumer = true;
          // list1.buChangeQty = this.num1;
          // list2.buChangeQty = this.num2;
          // list3.buChangeQty = this.num3;
        }
        list1.buChangeQty = this.num1;
        list2.buChangeQty = this.num2;
        list3.buChangeQty = this.num3;
        list1.leftNum = this.redNum1
        list2.leftNum = this.redNum2
        list3.leftNum = this.redNum3

        this.numList = {
          changeType: this.isChangeNumer,
          list1,
          list2,
          list3,
          popData: this.popData,
          assignEndTime:this.timeItem.assignEndTime,
          assignStartTime:this.timeItem.assignStartTime,
          redNumall:this.redNumall
        };
      }
      // console.log( this.numList,' this.numList');
      this.$emit("saveChange", this.numList);
    },
    handleChange1(value) {
      this.num1 = value;
    },
    handleChange2(value) {
      this.num2 = value;
    },
    // 变更分配数目
    handleChange3(value) {
      this.num3 = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-item {
  padding: 0px 10px 20px 30px;
  // background-color: #ffffff;
  color: #101010;
  // border-radius: 10px;
  font-family: SourceHanSansSC-bold;
  font-size: 14px;
  text-align: left;
  // ::v-deep.el-tabs__item.is-active {
  //     background-color: #FFFFFF;
  //     color: #409EFF;
  // }
  .btn {
    display: flex;
    width: 20%;
    margin-left: 80%;
    height: 42px;
    line-height: 42px;
  }
  .red {
    color: #cd1231;
    font-size: 16px;
    font-weight: bold;
    margin-top: -40px;
    height: 38px;
    line-height: 38px;
  }
  .item {
    height: 38px;
    line-height: 38px;
    display: flex;
    .left {
      font-size: 16px;
      font-weight: bold;
      width: 20%;
    }
    .right {
      flex: 1;
      font-size: 14px;
    }
  }
  .item-height {
    height: 45px;
    line-height: 45px;
    display: flex;
    .left {
      font-size: 16px;
      font-weight: bold;
      width: 20%;
    }
    .right {
      flex: 1;
      font-size: 14px;
      .left-30 {
        margin-left: 30px;
      }
      .right-30 {
        margin-right: 30px;
      }
    }
  }
  .item-height2 {
    height: 100px;
    line-height: 45px;
    display: flex;
    .left {
      font-size: 16px;
      font-weight: bold;
      width: 20%;
    }
    .right {
      flex: 1;
      font-size: 14px;
      .right-top {
        color: #cd1231;
        display: flex;
      }
      .left-30 {
        margin-left: 30px;
      }
      .right-30 {
        margin-right: 30px;
      }
      .right-40 {
        margin-right: 50px;
      }
      .right-change {
        display: flex;
        .number {
          width: 150px;
        }
      }
    }
  }
  .item-time {
    line-height: 25px;
    display: flex;
    color:#cd1231;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    .item-time-left {
      width: 20%;
    }
    .item-time-right {
      flex: 1;
      color:#101010;
      font-weight: normal;
      .item-span {
        margin-right: 20px;
      }
    }
  }
  .line-reason {
    border:1px dashed #000000;
    height:0;
    opacity: 0.1;
  }
}
</style>
